<mat-toolbar class="menu-bar">
    <a matButton="filled" routerLink="" routerLinkActive="router-link-active navMenuItemActive"
        [routerLinkActiveOptions]="{exact:true}">Club</a>
    <a mat-flat-button routerLink="termine"
        routerLinkActive="router-link-active navMenuItemActive">Termine</a>
    <a matButton="filled" routerLink="boote"
        routerLinkActive="router-link-active navMenuItemActive">Boote</a>
    <a matButton="filled" routerLink="jugend"
        routerLinkActive="router-link-active navMenuItemActive">Jugend</a>
    <a matButton="filled" routerLink="regatta"
        routerLinkActive="router-link-active navMenuItemActive">Regatta</a>
    @if(breakpointService.breakpoint() === 'DESKTOP') {
    <a matButton="filled" routerLink="links"
        routerLinkActive="router-link-active navMenuItemActive">Links</a>
    }
    <a matButton="filled" routerLink="kontakt"
        routerLinkActive="router-link-active navMenuItemActive">Kontakt</a>
    @if(breakpointService.breakpoint() === 'DESKTOP') {
    <a matButton="filled" routerLink="wetter"
        routerLinkActive="router-link-active navMenuItemActive">Wetter</a>
    }
    <a matButton="filled" routerLink="videos"
        routerLinkActive="router-link-active navMenuItemActive">Videos</a>
    <a matButton="filled" routerLink="member"
        routerLinkActive="router-link-active navMenuItemActive">Mitglieder</a>
    <!-- <a matButton="filled"><mat-icon>more</mat-icon></a> -->
</mat-toolbar>